<!-- Modified by Karanam on Oct 09 2026 to fix code review comment F-01: new FAQ page (spec 6.3). Native details/summary keeps it dependency-free and accessible. -->
<div class="faq-page">
  <h2 class="faq-title">Personal API Key &mdash; FAQ</h2>
  <p class="faq-intro">Answers to common questions about connecting AI tools to SSM NextGen.</p>

  <details class="faq-item" *ngFor="let item of faqItems; trackBy: trackByQuestion">
    <summary class="faq-question">{{ item.question }}</summary>
    <p class="faq-answer">{{ item.answer }}</p>
    <!-- Modified by Karanam on Oct 15 2026 to fix code review comment (setup instructions): optional numbered steps, config snippet and note for the Claude Desktop setup item. -->
    <ol class="faq-steps" *ngIf="item.steps">
      <li *ngFor="let step of item.steps">{{ step }}</li>
    </ol>
    <pre class="faq-code" *ngIf="item.code">{{ item.code }}</pre>
    <p class="faq-note" *ngIf="item.note">{{ item.note }}</p>
  </details>
</div>
